<template>
  <div class="posts-in-row">
    <template v-if="posts && posts.length">
      <span v-for="(post, index) in posts" :key="index">
        {{ post }}<span v-if="index + 1 < posts.length">,&nbsp;</span>
      </span>
    </template>
    <span v-else>{{ $t('labels.not_specified') }}</span>
  </div>
</template>
<script>
  export default {
    name: 'postsInRow',
    props: {
      posts: Array
    }
  }
</script>
<style lang="scss">
.posts-in-row {
  display: inline-block;
}
</style>